import React from "react";
import { UserEdit } from "../../components/Administration/UserPages/UserEdit";
import { UserAdd } from "../../components/Administration/UserPages/UserAdd";
interface UserEditPageProps {
	userPrincipalName: string;
}

function preventNavigation(ev: BeforeUnloadEvent) {
	ev.preventDefault();
	return (ev.returnValue = "There are unsaved changes. Are you sure you want to close?");
}

function togglePageNavigationBlocking(isBlocking: boolean) {
	if (isBlocking) {
		window.addEventListener("beforeunload", preventNavigation);
	} else {
		window.removeEventListener("beforeunload", preventNavigation);
	}
}

/**
 * This page takes in the user principal name from the router and if that userName is "new" it initiates on the user add page and
 * swapes to the user edit page when the new username is passed back from the userAdd component and swaps to the UserEit component.
 * Otherwise the page just renders the UserEdit Component passing in the UsePrincipalName given to the page.
 */
export const UserEditPage = (props: UserEditPageProps) => {
	const [userName, setUserName] = React.useState(props.userPrincipalName);

	return (
		<div>
			{userName !== "new" ? (
				<UserEdit userPrincipalName={userName} togglePageNavigationBlocking={togglePageNavigationBlocking}></UserEdit>
			) : (
				<UserAdd setUserName={setUserName}></UserAdd>
			)}
		</div>
	);
};
